var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRightArrow = function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 55 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.005 28.776a.765.765 0 0 1 0-1.08L52.4 15.263H.761A.76.76 0 0 1 0 14.5a.764.764 0 0 1 .76-.763h51.641L40.005 1.303a.764.764 0 0 1 .83-1.245.762.762 0 0 1 .246.166L54.777 13.96a.764.764 0 0 1 0 1.08L41.08 28.776a.76.76 0 0 1-1.076 0Z"
  })));
};
export default SvgRightArrow;